module.exports = __webpack_public_path__ + "static/img/excel.99067e72.svg";